import { combineReducers } from 'redux';
import ambassador from 'products/global/views/Ambassador/state';
import forgotPassword from 'products/global/views/ForgotPassword/state';
import profile from 'products/global/views/Profile/state';
import nps from 'products/global/views/NPS/state';

// ================== Reducers ================== //

const globalReducer = combineReducers({
  ambassador,
  forgotPassword,
  profile,
  nps
});

export default globalReducer;
